import React from 'react'

import {PassportUserContext} from './types'

export const PassportContext = React.createContext<PassportUserContext>(null)
